import { observable, action, computed} from 'mobx';
import Bunker from '../objects/bunker';


export default class ReceptionBunkersStore {
    @observable receptionBunker;

    constructor(bunkersList){
        this.receptionBunker  = [
            new Bunker(0,60,'testbunker1',"corn",1000,1,1),
            new Bunker(1,60,'testbunker1',"corn",10040,5,5),
            new Bunker(3,60,'testbunker1',"corn",10040,55,55),
            new Bunker(2,60,'testbunker1',"rape",10040,10,10),
            new Bunker(3,60),

            // new Bunker(60,'truck','testbunker2',"rape",10040,15,15),
            // new Bunker(60,'truck','testbunker3',"rape",10040,18,18)
        ];
    }


    @computed get getLineColor(){
        let result = this.receptionBunker.find(item=>item.status === 'clogged');
        if(result) {return 'clogged'} else{
            result = this.receptionBunker.find(item=>item.active);
            if (result)return result.culture;
        }
        return 'None'
    }

}


// WEBPACK FOOTER //
// ./src/shared/stores/GameSessionStore/ReceptionBunkersStore.js